"use client";

import { ReactNode, useEffect } from "react";
import { useProfileStore } from "@/store/profileStore";
import { useWebSiteStore } from "@/store/isWebSiteStore";

interface HydrateProfileProps {
  profile: any;
  isWebSite: boolean;
  children: ReactNode;
}

export function HydrateProfile({
  profile,
  isWebSite,
  children,
}: Readonly<HydrateProfileProps>) {
  const setProfile = useProfileStore((state: any) => state.setProfile);
  const setWebSiteCheck = useWebSiteStore((state: any) => state.setWebSite);
  useEffect(() => {
    setProfile(profile);
    setWebSiteCheck(isWebSite);
  }, [profile, isWebSite, setProfile, setWebSiteCheck]);

  return <>{children}</>;
}
